import { Pipe, type PipeTransform } from '@angular/core';
import { EntityStatus } from '@core';

import { type FloorSpaceModel } from '../models';

@Pipe({ name: 'avsFloorSpaceByName' })
export class FloorSpaceByNamePipe implements PipeTransform {
  transform(items: FloorSpaceModel[], searchText: string, showArchived = false) {
    if (!items) {
      return [];
    }

    // Filter floors based on archived status
    const floorsToProcess = items.filter(floor => {
      if (showArchived) {
        return floor.status === EntityStatus.Archived || floor.rooms?.some(room => room.status === EntityStatus.Archived);
      }

      return floor.status !== EntityStatus.Archived;
    });

    // Return early if search text is not provided
    if (!searchText) {
      return floorsToProcess;
    }

    // Filter by friendly name based on search text
    searchText = searchText.toLocaleLowerCase();

    return floorsToProcess.filter(floor => floor.friendlyName.toLocaleLowerCase().includes(searchText));
  }
}
